module.exports = __webpack_public_path__ + "f7d4bd8347cb38f149a9b643eebcfbf0.ttf";